import { cartResponseSchema } from "@/networking/carts.api";
import { fetchApi } from "@/lib/api-helpers";
import { z } from "zod";

export const shippingOptionSchema = z.object({
  id: z.string(),
  title: z.string(),
  delivery_time_estimate: z.string().nullable(),
  price: z.number().nullish(),
  price_label: z.string().nullish(),
});

export type ShippingMethod = z.infer<typeof shippingOptionSchema>;

const shippingMethodInputSchema = z.object({
  shipping_method_id: z.string(),
});

export async function updateShippingMethod({
  cartToken,
  shippingMethodId,
}: {
  cartToken: string;
  shippingMethodId: string;
}) {
  return fetchApi({
    endpoint: `/carts/${cartToken}/shipping_method`,
    method: "POST",
    input: { shipping_method_id: shippingMethodId },
    inputSchema: shippingMethodInputSchema,
    outputSchema: cartResponseSchema,
  });
}
